<script>

import {
	defineComponent,
	watch,
	nextTick,
	computed,
	onMounted,
} from 'vue';

import { useSiteGlobal } from '@zyro-inc/site-modules/use/useSiteGlobal';

import GridInstagramFeed from '@zyro-inc/site-modules/components/elements/instagram-feed/GridInstagramFeed.vue';
import { useGridInstagramFeed } from '@zyro-inc/site-modules/components/elements/instagram-feed/useGridInstagramFeed';

export default defineComponent({
	components: {
		GridInstagramFeed,
	},

	props: {
		id: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
	},

	emits: ['media-loaded'],

	setup(props, context) {
		const { siteId } = useSiteGlobal();

		const id = computed(() => props.id);
		const elementData = computed(() => props.data);

		const getInstagramTokenHandler = async ({
			siteId: currentId,
			elementId,
		}) => {
			const res = await fetch(`${import.meta.env.VITE_BACKEND_API_URL}/u1/instagram/token/${currentId}/${elementId}`);
			const data = await res.json();

			return data.accessToken;
		};

		const {
			media,
			init,
		} = useGridInstagramFeed({
			elementId: id,
			elementData,
			siteId: siteId.value,
			getInstagramTokenHandler,
			getInstagramFeedHandler: async ({
				siteId: currentId,
				elementId,
			}) => {
				const res = await fetch(`${import.meta.env.VITE_BACKEND_API_URL}/u1/instagram/feed/${currentId}/${elementId}`);

				return res.json();
			},
		});

		onMounted(() => {
			init();
		});

		watch(media, async (value) => {
			if (value?.length) {
				await nextTick();

				context.emit('media-loaded');
			}
		}, {
			immediate: false,
		});

		return {
			media,
		};
	},
});
</script>

<template>
	<GridInstagramFeed
		:id="id"
		:media="media"
	/>
</template>
